import { Link } from 'react-router-dom';

const BACKEND_URL = "https://viajeros-backend.onrender.com";

function DestinoCard({ destino }) {

  const imagenUrl = destino.imagen
    ? `${BACKEND_URL}${destino.imagen}`
    : "";

  return (
    <div className="destino-card">
      <img src={imagenUrl} alt={destino.nombre} width="200" />

      <h3>{destino.nombre}</h3>

      <p className="descripcion-destino">
        {destino.descripcion}
      </p>

      <div className="botones">
        <Link to={`/destinos/${destino.id}`}>
          <button>Ver más</button>
        </Link>

        <Link to={`/reserva?destino=${destino.nombre}`}>
          <button>Reservar</button>
        </Link>
      </div>
    </div>
  );
}

export default DestinoCard;